import header from 'i18n/default/en/header.json';
import mainMenu from 'i18n/default/en/mainMenu';
import pendingPaymentAdvice from 'i18n/default/en/pendingPaymentAdvice';
import PalletType from 'i18n/default/en/PalletType';
import LiteralCurrency from 'i18n/default/en/LiteralCurrency';
import units from 'i18n/default/en/units';
import CustomPalletSize from 'i18n/default/en/CustomPalletSize';
import NumberOfItems from 'i18n/default/en/NumberOfItems';
import LoadInfo from 'i18n/default/en/LoadInfo';
import LoadInputs from 'i18n/default/en/LoadInputs';
import dates from 'i18n/default/en/dates';
import Addresses from 'i18n/default/en/Addresses';
import AddressFormModal from 'i18n/default/en/AddressFormModal';
import AddressSelector from 'i18n/default/en/AddressSelector';
import StopAddress from 'i18n/default/en/StopAddress';
import Quote from 'i18n/default/en/Quote';
import extraNames from 'i18n/default/en/extraNames';
import timePickers from 'i18n/default/en/timePickers';
import authLoginForm from 'i18n/default/en/authLoginForm';
import authSignUpForm from 'i18n/default/en/authSignUpForm';
import HandlingExtra from 'i18n/default/en/HandlingExtra';
import Stop from 'i18n/default/en/Stop';
import VehicleExtras from 'i18n/default/en/VehicleExtras';
import OrderStop from 'i18n/default/en/OrderStop';
import ShipmentCard from 'i18n/default/en/ShipmentCard';
import Orders from 'i18n/default/en/Orders';
import Summary from 'i18n/default/en/Summary';
import Login from 'i18n/default/en/Login';
import AddressesPage from 'i18n/default/en/AddressesPage';
import ModalSummary from 'i18n/default/en/ModalSummary';
import OrderSummary from 'i18n/default/en/OrderSummary';
import OrdersOrderDetail from 'i18n/default/en/OrdersOrderDetail';
import Order from 'i18n/default/en/Order';
import ModalOrderDetail from 'i18n/default/en/ModalOrderDetail';
import loads from 'i18n/default/en/loads';
import SuggestedTimes from 'i18n/default/en/SuggestedTimes';
import Downloads from 'i18n/default/en/Downloads';
import CreditCard from 'i18n/default/en/CreditCard';
import TypeOfOrderSelector from 'i18n/default/en/TypeOfOrderSelector';
import Recurring from 'i18n/default/en/Recurring';
import Settings from 'i18n/default/en/Settings';
import InviteUserModal from 'i18n/default/en/InviteUserModal';
import PaymentData from 'i18n/default/en/PaymentData';
import DriverMapError from 'i18n/default/en/DriverMapError';
import Faqs from 'i18n/default/en/Faqs';
import AdditionalDocuments from 'i18n/default/en/AdditionalDocuments';
import Communications from 'i18n/default/en/Communications';
import RecurringOrderSuggestions from 'i18n/default/en/RecurringOrderSuggestions';
import Error from 'i18n/default/en/Error';
import Users from 'i18n/default/en/Users';
import Tracking from 'i18n/default/en/Tracking';
import Dashboard from 'i18n/default/en/Dashboard';
import Catalog from 'i18n/default/en/Catalog';
import Emergencies from 'i18n/default/en/Emergencies';
import SignUp from 'i18n/default/en/SignUp';
import Profile from 'i18n/default/en/Profile';
import Landing from 'i18n/default/en/Landing';

const lang = {
  Emergencies,
  Catalog,
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  LoadInputs,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  OrdersOrderDetail,
  ModalSummary,
  OrderSummary,
  Order,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  PaymentData,
  DriverMapError,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Dashboard,
  SignUp,
  Profile,
  Landing
};

export default lang;
